import React, { useState } from 'react';
import { Box, Modal, SxProps } from '@mui/material';
import { NodonTheme } from '@client/style';
import { IElement } from '@shared/models/project.model';
import SearchField from '@ui/SearchField';
import RecipeSelectorTabs, {
  RecipeSelectorTab,
} from './components/RecipeSelectorTabs';
import RecipeSelectorSBEFMenu from './components/RecipeSelectorSBEFMenu';
import RecipeSelectorList from './components/RecipeSelectorList';
import { getSbefCodeFromElementOrRecipe } from '@shared/helpers/sbef.helpers';
import CloseButton from '@ui/CloseButton';

interface RecipeSelectorProps {
  element: IElement;
  onClose: () => void;
}

const RecipeSelector: React.FC<RecipeSelectorProps> = ({
  element,
  onClose,
}) => {
  const [searchString, setSearchString] = useState('');
  const [selectedSbefCode, setSelectedSbefCode] = useState(
    getSbefCodeFromElementOrRecipe(element),
  );
  const [selectedTab, setSelectedTab] = useState<RecipeSelectorTab>();

  return (
    <Modal open onClose={onClose} sx={modalStyles}>
      <Box
        role="dialog"
        aria-label="Recipe selector"
        tabIndex={-1}
        sx={containerStyles}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <CloseButton onClick={onClose} />
        </Box>

        <SearchField
          autoFocus
          placeholder="Search recipes"
          sx={searchFieldStyles}
          value={searchString}
          onChange={setSearchString}
        />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            height: HEADER_HEIGHT,
          }}
        >
          <RecipeSelectorSBEFMenu
            sbefCode={selectedSbefCode}
            onSelect={setSelectedSbefCode}
          />
          <RecipeSelectorTabs
            selectedTab={selectedTab}
            onChange={setSelectedTab}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            height: `calc(100% - ${HEADER_HEIGHT}px)`,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            <RecipeSelectorList
              element={element}
              sbefCode={selectedSbefCode}
              selectedTab={selectedTab}
              searchString={searchString}
              onClose={onClose}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

const HEADER_HEIGHT = 50;

const modalStyles: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as const;

const containerStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: 'calc(100% - 100px)',
  height: 'calc(100% - 100px)',
  background: NodonTheme.palette.background.default,
  borderRadius: 1,
} as const;

const searchFieldStyles: SxProps = { padding: '0px 20px 10px' } as const;

export default RecipeSelector;
